import type { CarrierSummary } from '../carrier/carrier.interface';
import { ObjectFactory } from './object.factory';

export class CarrierSummaryFactory extends ObjectFactory<CarrierSummary> {
  protected getDefaults(): CarrierSummary {
    return {
      code: 'DHL',
      id: 'eeeeeeeeeeeeeeeeeeeeeeee',
      name: 'DHL Express',
    };
  }
}

export const carrierSummaryFactory = new CarrierSummaryFactory();
